import { addDoc, collection, serverTimestamp } from "firebase/firestore"
import { auth, firestore } from "../firebase"

// Funnel events (trial -> sign-in -> pricing -> checkout) in the top-level
// `funnelEvents` log; only admins read it. Works logged out: anonId is a random
// per-browser id, and the "signed_in" event links it to the uid.
// Fire-and-forget; a tracking failure never blocks the user.

const ANON_KEY = "jewlai_anon_id"
const TRIAL_KEY = "jewlai_landing_trial"

function anonId() {
  try {
    let id = localStorage.getItem(ANON_KEY)
    if (!id) {
      id = typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`
      localStorage.setItem(ANON_KEY, id)
    }
    return id
  } catch (_) {
    return null
  }
}

function trialId() {
  try {
    const parsed = JSON.parse(localStorage.getItem(TRIAL_KEY) || "null")
    return typeof parsed?.trialId === "string" ? parsed.trialId.slice(0, 64) : null
  } catch (_) {
    return null
  }
}

const recent = new Map()

// type: pricing_view | generate_no_balance | generate_logged_out | checkout_click |
//       download_logged_out | save_intent_logged_out | signed_in
export function trackFunnel(type, { from, docId, url, method, plan, balance } = {}) {
  // Re-renders and double clicks must not inflate the counts.
  const key = `${type}|${docId || ""}|${method || ""}`
  const now = Date.now()
  if (now - (recent.get(key) || 0) < 10000) return
  recent.set(key, now)

  const user = auth.currentUser
  addDoc(collection(firestore, "funnelEvents"), {
    type,
    uid: user?.uid || null,
    email: user?.email || null,
    anonId: anonId(),
    trialId: trialId(),
    path: window.location.pathname.slice(0, 100),
    from: from ? String(from).slice(0, 100) : null,
    docId: docId ? String(docId).slice(0, 100) : null,
    url: url ? String(url).slice(0, 500) : null,
    method: method || null,
    plan: plan || null,
    balance: typeof balance === "number" ? balance : null,
    createdAt: serverTimestamp(),
  }).catch(() => {})
}
